import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import TCSValue from '../../../functions/tcsvalue';
import '../../PurchaseAndStock/PurchaseDetails/purchasedetails.css';
import $ from "jquery";
const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class MaxWidthDialog extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    data: []
  };

  removeTcsValue(items) {
    let newItem = [];
    items.map((c) => {
      if (c.partname != 'TCS') {
        newItem.push(c);
      }
    })
    return newItem;
  }

  setItems() {
    let newItems = [];
    let items = this.props.data;
    items = this.removeTcsValue(items);
    for (var i = 0; i < items.length; i++) {
      newItems.push({ tax: items[i].tax, total: items[i].total })
    }
    var tax = [];
    var data = [];
    $.each(newItems, function(index, value) {
        if($.inArray(value.tax, tax) == -1)
        {
          tax.push(value.tax);
          data.push(value);
        }
    });
    return data;
  }

  total(tax) {
    let total = 0;
    this.props.data.map((z)=>{
      if (z.partname != 'TCS') {
        if (tax == z.tax) {
          let quantity = 1;
          let uprice = 0;
          let discountPercentage = 0;
          let tax = 0;
          try {
            tax = Number(z.tax);
            if (z.discountper) {
              discountPercentage = Number(z.discountper);
            }
            if (z.quantity) {
              quantity = Number(z.quantity);
            }
            uprice = Number(z.uprice).toFixed(2);
            discountPercentage=Number(discountPercentage).toFixed(3);
          } catch (e) {
  
          }
          let discountPrice = ((uprice - ((uprice * discountPercentage)/100)) * quantity).toFixed(2);
          let taxPrice = ((discountPrice * tax)/100).toFixed(2);
          total = Number(total) + Number(taxPrice);
        }
      }
    });
    return total.toFixed(2);
  }

  totals(tax) {
    let total = 0;
    let sum = 0;
    let taxs = 0;
    this.props.data.map((z)=>{
      if (z.partname != 'TCS') {
        if (tax == z.tax) {
          total = z.totprices;
          taxs = total * (tax/100);
          sum = sum + taxs;
        }
      }
    });
    try {
      sum = sum.toFixed(2);
    } catch (e) {
    }
    return sum;
  }

  cgstTotal() {
    let total = 0;
    this.props.data.map((z)=>{
      if (z.partname != 'TCS') {
        if (z.tax == '' || z.tax == null) {

        }
        else {
          let quantity = 1;
          let uprice = 0;
          let discountPercentage = 0;
          let tax = 0;
          try {
  
            if (z.discountper) {
              discountPercentage = Number(z.discountper);
            }
            if (z.quantity) {
              quantity = Number(z.quantity);
            }
            tax = Number(z.tax);
            uprice = Number(z.uprice).toFixed(2);
            discountPercentage=Number(discountPercentage).toFixed(3);
          } catch (e) {
  
          }
          let discountPrice = ((uprice - ((uprice * discountPercentage)/100)) * quantity).toFixed(2);
          let taxPrice = ((discountPrice * tax)/100).toFixed(2);
          total = Number(total) + Number(taxPrice);
        }
      }
    });
    return total.toFixed(2);
  }

  totalCost() {
    let total = this.cgstTotal() * 2;
    try {
      total = total.toFixed(2);
    } catch (e) {

    }
    return total;
  }

  totalprice(tax) {
    let total = 0;
    this.props.data.map((z)=>{
      if (z.partname != 'TCS') {
        if (tax == z.tax) {

          let uprice = 0
          let discountPercentage = 0;
          let quantity = 1;
          try {
            uprice = Number(z.uprice);
            if (z.discountper) {
              discountPercentage = Number(z.discountper);
            }
            if (z.quantity) {
              quantity = Number(z.quantity);
            }
          } catch (e) {
          }
          let discountPrice = ((uprice - ((uprice * discountPercentage)/100)) * quantity).toFixed(2);
          total = Number(total) + Number(discountPrice);
        }
      }
      
    });
    try {
      total = total.toFixed(2);
    } catch (e) {

    }
    return total;
  }


  uprice() {
    let total = 0;
    this.props.data.map((z)=>{
      if (z.partname != 'TCS') {

          let uprice = 0
          let discountPercentage = 0;
          let quantity = 1;
          try {
            uprice = Number(z.uprice);
            if (z.discountper) {
              discountPercentage = Number(z.discountper);
            }
            if (z.quantity) {
              quantity = Number(z.quantity);
            }
          } catch (e) {
          }
          let discountPrice = ((uprice - ((uprice * discountPercentage)/100)) * quantity).toFixed(2);
        
          total = Number(total) + (Number(discountPrice));
    
      }
      
    })
    return total.toFixed(2);
  }

  getTotalAmount() {
    let tax = this.cgstTotal();
    let uprice = this.uprice();
    let total = Number(tax) + Number(uprice);
    if (this.props.customerTCS == '1' || this.props.customerTCS == 1) {
      total = total + ((total * TCSValue())/100);
    }
    return total.toFixed(2);
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeDecimalPoint(value) {
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }


  render() {
    let data = this.setItems();
    const { classes } = this.props;
    let tax = (<div></div>);
    let x = 0;
    let cgst = data.map((z) => {
      let out = (<div></div>);
      if (z.partname != 'TCS') {
        out = (
          <tr>
            {(x == 0) ? (<th rowspan={data.length}>CGST</th>) : null}
            <td width="(100/x)%">Total: {(this.totalprice(z.tax)/2).toFixed(2)}</td>
            <td width="(100/x)%">Tax: {z.tax/2}%</td>
            <td width="(100/x)%">Rs.  {(this.total(z.tax)/2).toFixed(2)}</td>
            {(x == 0) ? (<th rowspan={data.length} style={{fontSize: 16, color: '#3E71A4'}}>Rs. {(this.cgstTotal()/2).toFixed(2)}</th>) : null}
          </tr>
        );
        x++;
      }
      return out;
    });
    x  = 0;
    let sgst = data.map((z) => {
      let out = (<div></div>);
      if (z.partname != 'TCS') {
        out = (
          <tr>
            {(x == 0) ? (<th rowspan={data.length}>SGST</th>) : null}
            <td width="(100/x)%">Total: {(this.totalprice(z.tax)/2).toFixed(2)}</td>
            <td width="(100/x)%">Tax: {z.tax/2}%</td>
            <td width="(100/x)%">
              Rs.  {(this.total(z.tax)/2).toFixed(2)}
            </td>
            {(x == 0) ? (<th rowspan={data.length} style={{fontSize: 16, color: '#3E71A4'}}>Rs. {(this.cgstTotal()/2).toFixed(2)}</th>) : null}
          </tr>
        );
        x++;
      }
      return out;
    });
    x  = 0;

    let igst = data.map((z) => {
      let out = (<div></div>);
      if (z.partname != 'TCS') {
        
        out = (
          <tr>
            {(x == 0) ? (<th rowspan={data.length}>IGST</th>) : null}
            <td width="(100/x)%">Total: {this.totalprice(z.tax)}</td>
            <td width="(100/x)%">Tax: {z.tax}%</td>
            <td width="(100/x)%">Rs.  {(this.total(z.tax))}</td>
            {(x == 0) ? (<th rowspan={data.length} style={{fontSize: 16, color: '#3E71A4'}}>Rs. {this.cgstTotal()}</th>) : null}
          </tr>
        );
        x++;
      }
      return out;
    });

    if (this.props.branchState == this.props.purchaseState) {
      tax = (
        <table id="table" width="100%">
          <tbody>{cgst}</tbody>
          <tbody>{sgst}</tbody>
          { this.props.customerTCS == '1' || this.props.customerTCS == 1 ?
            (
              <tbody>
                { 
                  this.props.data.map((c) => {
                    if (c.partname == 'TCS') {
                      let total = this.convertIntoNumber(c.totals);
                      let tax = this.convertIntoNumber(c.tax);
                      let taxAmount = ((total * tax)/100);
                      return (
                        <tr>
                          <td><center><b>TCS</b></center></td>
                          <td>{'Total: '+this.makeDecimalPoint(total)}</td>
                          <td>{'Tax : '+tax+' %'}</td>
                          <td>{'Rs. '+ this.makeDecimalPoint(taxAmount)}</td>
                          <td style={{fontSize: 16, color: '#3E71A4'}}><center><b>{'Rs. '+ this.makeDecimalPoint(taxAmount)}</b></center></td>
                        </tr>
                      )
                    }
                  })
                }
              </tbody>
            ):''
          }
          
          <tbody>
          <tr>
            {
              this.props.customerTCS == '1' || this.props.customerTCS == 1 ? 
              (<th colspan="3" style={{fontSize: 16}}>(CGST + SGST + TCS + TOTAL)</th>) :
              (<th colspan="3" style={{fontSize: 16}}>(CGST + SGST + TOTAL)</th>)
            }
            
            <th colspan="2" style={{color: '#3E71A4', fontSize: 16}}>Rs. {this.getTotalAmount()}</th>
          </tr>
          </tbody>
        </table>

      )
    }
    else {
      tax = (
        <table id="table" width="100%">
          <tbody>{igst}</tbody>
          { 
            this.props.data.map((c) => {
              if (c.partname == 'TCS') {
                return (
                  <tr>
                    <td><center><b>TCS</b></center></td>
                    <td>{'Total: '+c.totals}</td>
                    <td>{'Tax : '+c.tax+' %'}</td>
                    <td>{'taxAmount'}</td>
                    <td>{'TotPrice'}</td>
                  </tr>
                )
              }
            })
          }
          <tbody>
          <tr>
            {
              this.props.customerTCS == '1' || this.props.customerTCS == 1 ? 
              (<th colspan="3" style={{fontSize: 16}}>(IGST + TCS + TOTAL)</th>) :
              (<th colspan="3" style={{fontSize: 16}}>(IGST + TOTAL)</th>)
            }
            
            <th colspan="2" style={{color: '#3E71A4', fontSize: 16}}>Rs. {this.getTotalAmount()}</th>
          </tr>
          </tbody>
        </table>
      )
    }
    return (
      <div>
        {tax}
      </div>
    );
  }
}

MaxWidthDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MaxWidthDialog);
